import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  faLock,
  faPen,
  faSortUp,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { CheckboxComponent } from '../../checkbox/checkbox.component';

@Component({
  selector: 'mpro-checkable-dropdown-item',
  templateUrl: './checkable-dropdown-item.component.html',
  styleUrls: [
    './../dropdown-item.scss',
    './checkable-dropdown-item.component.scss',
  ],
  host: {
    '[class.disabled]': 'disabled',
    '[class.readonly]': 'readonly',
  },
})
export class CheckableDropdownItemComponent implements OnChanges {
  public faSortUp = faSortUp;
  public faLock = faLock;
  public faTrash = faTrash;
  public faPen = faPen;

  public expanded: boolean;

  @ViewChild(CheckboxComponent) public checkbox: CheckboxComponent;

  @Input() public disabled: boolean;
  @Input() public readonly: boolean = false;
  @Input() public loading: boolean = false;
  @Input() public editable: boolean = false;
  @Input() public showLock: boolean = false;
  @Input() public indeterminate: boolean = false;

  @Input() public leftText: string;
  @Input() public rightText?: string;

  @Input() public checked: boolean = false;
  @Input() public arrow: boolean = false;

  @Input() public overrideCheckbox: boolean = false;

  @Output() public itemChecked: EventEmitter<boolean> = new EventEmitter();
  @Output() public editClicked: EventEmitter<void> = new EventEmitter();
  @Output() public deleteClicked: EventEmitter<void> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.checked &&
      changes.checked.currentValue !== changes.checked.previousValue
    ) {
      this.checkbox?.writeValue(changes.checked.currentValue);
    }
  }

  public onCheckedChange(checked: boolean) {
    if (this.disabled) {
      return;
    }
    const checkedValue = this.overrideCheckbox ? this.checked : checked;
    this.checkbox?.writeValue(checkedValue);
    this.itemChecked.emit(checkedValue);
  }

  public onEditClick() {
    if (this.disabled) {
      return;
    }
    this.editClicked.emit();
  }

  public onDeleteClick() {
    if (this.disabled) {
      return;
    }
    this.deleteClicked.emit();
  }
}
